import { Cartesian3, Cartographic, Color, HeightReference, Viewer , Math as MathCesium, Cartesian2 } from "cesium";

interface IpositionCamera {
    x: number,
    y: number,
    z: number
}

export interface IViewSave {
    position: IpositionCamera,
    heading?: number,
    pitch?: number,
    roll?: number
}

export interface IViewSave2D {
    long: number,
    lat: number,
    height: number,
}

export const saveViewCamera = (viewer: Viewer): IViewSave => {
    const camera = viewer.camera;


    const viewSave: IViewSave = {
        position: camera.positionWC.clone(),
        heading: camera.heading,
        pitch: camera.pitch,
        roll: camera.roll,
    }

    return viewSave
}

export const saveViewCamera2D = (viewer: Viewer): IViewSave2D => {
    const canvas = viewer.canvas;

    const center = viewer.camera.pickEllipsoid(
        new Cartesian2(canvas.clientWidth / 2, canvas.clientHeight / 2),
        viewer.scene.globe.ellipsoid
    );

    if (!center) throw new Error("Cannot get center");

    const carto = Cartographic.fromCartesian(center);

    return {
        long: MathCesium.toDegrees(carto.longitude),
        lat: MathCesium.toDegrees(carto.latitude),
        height: viewer.camera.positionCartographic.height
    };
};
export const loadViewCamera = (viewer: Viewer, viewSave: IViewSave) => {
    const camera = viewer.camera;


    // Khôi phục lại vị trí camera từ viewSave.position
    const position = new Cartesian3(viewSave.position.x, viewSave.position.y, viewSave.position.z);
    camera.setView({
        destination: position,
        orientation: {
            heading: viewSave.heading,
            pitch: viewSave.pitch,
            roll: viewSave.roll
        }
    });
}

export const loadViewCamera2D = (viewer: Viewer, view: IViewSave2D) => {
    viewer.camera.setView({
        destination: Cartesian3.fromDegrees(
            view.long,
            view.lat,
            view.height
        )
    });
};
export interface IDataPoint {
    position: Cartesian3,
    color?: Color | string,
    outlineColor?: Color | string,
    outlineWidth?: number,
    pixelSize?: number,
    heightReference?: any,
    disableDepthTestDistance?: any
}

export const createPoint = (viewer: Viewer, dataPoint: IDataPoint) => {
    viewer.entities.add({
        position: dataPoint.position,
        point: {
            pixelSize: dataPoint.pixelSize ?? 10,
            color: (typeof dataPoint.color === 'string') ? Color.fromCssColorString(dataPoint.color) : dataPoint.color ?? Color.GREENYELLOW,
            outlineColor: (typeof dataPoint.outlineColor === 'string') ? Color.fromCssColorString(dataPoint.outlineColor) : dataPoint.outlineColor ?? Color.WHITE,
            outlineWidth: dataPoint.outlineWidth ?? 2,
            heightReference: dataPoint.heightReference ?? HeightReference.NONE,
            disableDepthTestDistance: dataPoint.disableDepthTestDistance ?? Number.POSITIVE_INFINITY
        }
    })
}